module.exports = __webpack_public_path__ + "static/painter-e5b93c936e02ab8860a43e4b7f372bd7.svg";